import {
  JudgePopupTypeCutOnce,
  JudgePopupTypeNewCutOnce
} from '@/views/global-modal/modal/common/util/judgePopupType/judgePopupTypeCutOnce'
import Manager from '@/context/manager'

export type OpenModalParams = {
  /** 是否登录触发 */
  isLoginTrigger: boolean
  /** 活动id */
  activeId: number
  /** 是否永不提示 */
  isNeverPop: boolean
  /** 是否本次不再提示提示 */
  isThisTimeNoPop: boolean
}

const judgePopupTypeCutOnce = new JudgePopupTypeCutOnce()

/** 打开抽奖助力弹窗 */
export const proxyOpenCutOnceModal = async (params: OpenModalParams) => {
  const { isLoginTrigger, activeId, isNeverPop, isThisTimeNoPop } = params

  // 判断是否永不提示 或者本次不再提示弹窗
  if (isNeverPop || isThisTimeNoPop) {
    return
  }

  // 根据当前页面地址判断是否需要禁用弹窗
  const isOpenable = (
    await import(
      '@/views/global-modal/modal/common/util/judgeIsForbidPopByPageAddress'
    )
  ).judgeIsForbidPopByPageAddress()
  if (isOpenable) {
    return
  }

  // 根据后台配置的弹窗类型来判断当前是否弹出
  const isForbid = await !judgePopupTypeCutOnce.run({ isLoginTrigger })
  if (isForbid) {
    return
  }
  await new Promise((resolve) => {
    // 打开弹窗
    Manager.Modal.open('cutOnce', {
      activeId,
      isHomeModal: true
    }).then((context) => {
      context.$once('modal:close', () => {
        resolve(undefined)
      })
    })
  })
}

const judgePopupTypeNewCutOnce = new JudgePopupTypeNewCutOnce()

/** 打开新砍一刀弹窗 */
export const proxyOpenNewCutOnceModal = async (params: OpenModalParams) => {
  const { isLoginTrigger, activeId, isNeverPop, isThisTimeNoPop } = params

  // 判断是否永不提示 或者本次不再提示弹窗
  if (isNeverPop || isThisTimeNoPop) {
    return
  }

  // 根据当前页面地址判断是否需要禁用弹窗
  const isOpenable = (
    await import(
      '@/views/global-modal/modal/common/util/judgeIsForbidPopByPageAddress'
    )
  ).judgeIsForbidPopByPageAddress()
  if (isOpenable) {
    return
  }

  // 根据后台配置的弹窗类型来判断当前是否弹出
  const isForbid = await !judgePopupTypeNewCutOnce.run({ isLoginTrigger })
  if (isForbid) {
    return
  }
  await new Promise((resolve) => {
    // 打开弹窗
    Manager.Modal.open('newCutOnce', {
      activeId,
      isHomeModal: true
    }).then((context) => {
      context.$once('modal:close', () => {
        resolve(undefined)
      })
    })
  })
}
